export default __webpack_public_path__ + "static/media/lightbulb_v2.6b2bec43.svg";